//用户管理
export default [
  {
    path: '/vehicleManage',
    component: () => import('../pages/vehicleMAnage/vehicleManage.vue'),
    name: 'vehicleManage',
    title: '车辆录入',
    meta: {
      title: '车辆录入',
    },
  },
  {
    path: '/parikingLotManage',
    component: () => import('../pages/vehicleMAnage/parikingLotManage.vue'),
    name: 'parikingLotManage',
    title: '停车场管理',
    meta: {
      title: '停车场管理',
    },
  },
  {
    path: '/vehicleCoupon',
    component: () => import('../pages/vehicleMAnage/vehicleCoupon.vue'),
    name: 'vehicleCoupon',
    title: '停车券管理',
    meta: {
      title: '停车券管理',
    },
  },
  {
    path: '/vehicleCouponQRcode',
    component: () => import('../pages/vehicleMAnage/vehicleCouponQRcode.vue'),
    name: 'vehicleCouponQRcode',
    title: '停车券领取',
    meta: {
      title: '停车券领取',
    },
  },
  {
    path: '/vehicleCouponReciveLogs',
    component: () =>
      import('../pages/vehicleMAnage/vehicleCouponReciveLogs.vue'),
    name: 'vehicleCouponReciveLogs',
    title: '停车券领取记录',
    meta: {
      title: '停车券领取记录',
    },
  },
  {
    path: '/stockChangeLogs',
    component: () => import('../pages/vehicleMAnage/stockChangeLogs.vue'),
    name: 'stockChangeLogs',
    title: '库存修改记录',
    meta: {
      title: '库存修改记录',
    },
  },
  {
    path: '/paymentLogs',
    component: () => import('../pages/vehicleMAnage/paymentLogs.vue'),
    name: 'paymentLogs',
    title: '缴费记录',
    meta: {
      title: '缴费记录',
    },
  },
  {
    path: '/vehicleCouponStock',
    component: () => import('../pages/vehicleMAnage/vehicleCouponStock.vue'),
    name: 'vehicleCouponStock',
    title: '停车券库存',
    meta: {
      title: '停车券库存',
    },
  },
]
